"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markRequiredText = void 0;
var _react = _interopRequireDefault(require("react"));
var markRequiredText = exports.markRequiredText = function markRequiredText(text) {
  return /*#__PURE__*/_react["default"].createElement("span", null, text, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-danger"
  }, "*"));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/requiredTextLabel.js
// module id = 2088
// module chunks = 9